import React from 'react';
import CardHeader from '../../components/CardHeader';
import UpButton from '../../components/Common/UpButton';

import HelpText from '../Login/HelpText';
import { useMutation } from '@tanstack/react-query';
import { acceptInviteAccess } from '../../api/auth';
import LocalStorageHelper from '../../helpers/localStorageHelpers';
import { useNavigate } from 'react-router-dom';
import { checkErrorTypeString } from '../../helpers/utils';
import UpToast from '../../components/Common/UpToast';
import UpLoadingCover from '../../components/Common/UpLoadingCover';
import UpLoadingBar from '../../components/Common/UpLoadingBar';

function PendingInvite() {
  const navigate = useNavigate();
  const { isMobile, emailMobile, countryCode } =
    LocalStorageHelper.getUserDetails();

  const handleSubmit = e => {
    e.preventDefault();

    if (loading) {
      return;
    }
    const params = {
      ...(isMobile
        ? { phone: emailMobile, isd_code: countryCode }
        : { email: emailMobile }),
    };
    callAcceptInviteAccess(params);
  };

  const { isLoading: loading, mutate: callAcceptInviteAccess } = useMutation({
    mutationFn: acceptInviteAccess,
    onSuccess: response => {
      if (response?.access_token) {
        LocalStorageHelper.setAccessToken(response?.access_token);
      }
      navigate('/invite/auth-access');
    },
    onError: error => {
      const errorMessage = checkErrorTypeString(error?.response?.data?.message);
      UpToast.error(errorMessage);
    },
  });

  return (
    <div>
      <UpLoadingBar loading={loading} />
      <div className="dark-view-wrapper relative">
        <UpLoadingCover loading={loading} />
        <div className="flex-grow">
          <CardHeader title="Accept your invite " />
          <form onSubmit={handleSubmit}>
            <div className="mt-12 mb-8">
              You already have an invite from your admin waiting. Accept it via
              your email or the message sent to your mobile number, or click
              ‘Get Started’ to accept and activate your account
            </div>
            <UpButton type="submit" loading={loading}>
              Get started
            </UpButton>
          </form>
        </div>
        <HelpText screen="landing" />
      </div>
    </div>
  );
}

export default PendingInvite;
